export default __webpack_public_path__ + "static/media/hostfully_step3.9f2b184c.png";